import { END_OF_TODAY, START_OF_TODAY } from "@/utils/dateUtils";

export const dateOptions = [
  {
    id: "today",
  },
  {
    id: "yesterday",
  },
  {
    id: "last_three_days",
  },
  {
    id: "tomorrow",
  },
  {
    id: "next_two_days",
  },
  {
    id: "custom_range",
    start: START_OF_TODAY,
    end: END_OF_TODAY,
    startTime: START_OF_TODAY,
    endTime: END_OF_TODAY,
  },
];
